/**
 * new-hmp-design-goal-navigator.js
 * ---------------------------------------------------------------
 * Lightweight controller for the "I want to..." carousel.
 * Scrolling itself is native CSS scroll-snap (cheap, no JS on the
 * scroll path, no INP risk). This file only wires the two arrow
 * buttons and keeps their enabled/disabled state in sync so
 * keyboard/switch-device users get correct affordances (ADA).
 *
 * THEME EDITOR NOTE:
 * When a merchant adds, duplicates, or reorders this section inside
 * the Shopify theme editor, the editor swaps in new section HTML via
 * AJAX rather than a full page reload -- that's exactly what makes a
 * freshly-added section behave differently from a real page load
 * ("looks fine live, not fine in the editor"). Shopify fires a
 * `shopify:section:load` event on the section's container specifically
 * so section scripts can re-run their init logic against just that
 * section. Every interactive "new-hmp-design" section listens for
 * this event for that reason -- skipping it is the #1 cause of
 * editor-vs-live mismatches in custom Shopify sections.
 */
(function () {
  'use strict';

  function initCarousel(section) {
    if (section.dataset.hmpGoalNavInit === 'true') return; // avoid double-binding
    var track = section.querySelector('[data-goal-nav-track]');
    var prevBtn = section.querySelector('[data-goal-nav-prev]');
    var nextBtn = section.querySelector('[data-goal-nav-next]');
    if (!track || (!prevBtn && !nextBtn)) return;
    section.dataset.hmpGoalNavInit = 'true';

    function cardWidth() {
      var firstCard = track.querySelector('.new-hmp-design-goal-card');
      return firstCard ? firstCard.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    }

    function updateArrowState() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateArrowState, { passive: true });
    window.addEventListener('resize', updateArrowState);
    updateArrowState();
  }

  function initAll(root) {
    root
      .querySelectorAll('[data-section-type="new-hmp-design-goal-navigator"]')
      .forEach(initCarousel);
    // root itself might be the section (theme editor passes the section element directly)
    if (root.dataset && root.dataset.sectionType === 'new-hmp-design-goal-navigator') {
      initCarousel(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Guard against this listener being registered more than once if the
  // theme editor re-executes this script file for multiple section loads.
  if (!window.__newHmpGoalNavListenerBound) {
    window.__newHmpGoalNavListenerBound = true;
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  }
})();
